import { Col, InputField, Quantity, Row, Tooltip } from "client/CommonComponents"
import { formatPrice, isMaxLength, isNumber } from "utils"
import './KitAttribute.scss'

const KitAttribute = (props:any) => {

    const { 
        handleChangeKitAttribute, 
        increamentAddedQuantity, 
        decrementAddedQuantity, 
        kitError, 
        priceFormat,
        getTotalKitPrice 
    } = props

    return(<Row>
        <Col xs={12} md={12} lg={12}>
            <div className="admin-sttepper-content kit-attr kitHeaderBlock">
                <div className="header-block">
                    <p className="header"></p>
                    <p className="desc1">Kit Description 1</p>
                    <p className="desc2">Kit Description 2</p>
                    <p className="qty">Quantity</p>
                    <p className="kunit_price">Kit Unit Price</p>
                    <p className="status"></p>
                </div>
                <div className="content-block">
                    <div className="content-with-warning">
                        <div className="content-card">
                            <p className="header"></p>
                            <p className="desc1 tooltip-description">
                                <Tooltip content={props?.state?.kitDescription1 ? props?.state?.kitDescription1 : null} data-attribute="KitAttribute_Default_Tooltip">
                                <InputField 
                                    placeholder="Enter Description 1"
                                    name='kitDescription1' 
                                    type='text' 
                                    onChange={props?.handleOnChange} 
                                    value={props?.state?.kitDescription1}
                                    className={kitError?.kitDescription1 ? 'controlValidation' : "" }
                                     data-attribute="KitAttribute_kitDescription1_Input" />
                                    </Tooltip>
                                    {kitError?.kitDescription1 ? <p className='validMessage'>{kitError?.kitDescription1}</p> : ""}
                            </p>                         
                            <p className="desc2 tooltip-description">
                            <Tooltip content={props?.state?.kitDescription2 ? props?.state?.kitDescription2 : null} data-attribute="KitAttribute_Default_Tooltip_2">
                                <InputField 
                                    placeholder="Enter Description 2"
                                    name='kitDescription2' 
                                    type='text' 
                                    onChange={props?.handleOnChange} 
                                    value={props?.state?.kitDescription2}
                                    className={kitError?.kitDescription2 ? 'controlValidation' : "" }
                                 data-attribute="KitAttribute_kitDescription2_Input" />
                                </Tooltip>
                                {kitError?.kitDescription2 ? <p className='validMessage'>{kitError?.kitDescription2}</p> : ""}
                            </p>                          
                            <p className="qty">
                                <Quantity
                                    increment={props?.incrementQuantity}
                                    decrement={props?.decrementQuantity}
                                    value={props?.quantity}
                                    disableFlg={props?.quantity <= 1}
                                    onChange={props?.handleOnChange}
                                    name='quantity'
                                    onKeyPress={(event: any) => { isMaxLength(event, 3); isNumber(event); }}
                                    //className={kitError?.quantity ? 'controlValidation' : "" }
                                 data-attribute="KitAttribute_quantity_Quantity" />
                                 {kitError?.quantity ? <p className='validMessage'>{kitError?.quantity}</p> : ""}
                            </p>                          
                            <p className="kunit_price">
                                <InputField 
                                    placeholder="Enter Unit Price"
                                    name='unitPrice' 
                                    prefix='$'
                                    onChange={props?.handleOnChange} 
                                    value={props?.state.unitPrice || ''}
                                    onKeyPress={(event: any) => { isNumber(event) }}
                                    onBlur={(event: any) => priceFormat(event, 'unitPrice')}
                                    className={kitError?.unitPrice ? 'controlValidation' : "" }
                                     data-attribute="KitAttribute_unitPrice_Input" />
                                    {kitError?.unitPrice ? <p className='validMessage'>{kitError?.unitPrice}</p> : ""}
                            </p>                          
                            <button className="status" onClick={props?.handleClickAddNewRow} data-attribute="KitAttribute_Default_Button">
                            <div className="plusicon">
                                    <span className="fa fa-plus"></span>
                                </div>
                            </button>                                       
                        </div>
                    </div>
                        {
                            props?.kitAttributeValues?.map((itemValue: any, index: any) => {
                                return (
                                    <div className="content-with-warning" key={itemValue.kitNumber}>
                                        <div className="content-card">
                                            <p className="header"><b>Kit {index + 1}</b></p>
                                            <p className="desc1 tooltip-description">
                                                <Tooltip content={itemValue?.kitDescription1 ? itemValue?.kitDescription1 : null} data-attribute="KitAttribute_Default_Tooltip_3">
                                                <InputField
                                                    name="kitDescription1"
                                                    placeholder="Enter Description 1"
                                                    value={itemValue?.kitDescription1}
                                                    onChange={(e: any) => handleChangeKitAttribute(e, itemValue.kitNumber)}
                                                    className={itemValue?.kitErrors?.kitDescription1 ? 'controlValidation' : "" }
                                                 data-attribute="KitAttribute_kitDescription1_Input_2" />
                                                </Tooltip>
                                                {itemValue?.kitErrors?.kitDescription1 ? <p className='validMessage'>{itemValue?.kitErrors?.kitDescription1}</p> : ""}
                                            </p>                                          
                                            <p className="desc2 tooltip-description">
                                            <Tooltip content={itemValue?.kitDescription2 ? itemValue?.kitDescription2 : null} data-attribute="KitAttribute_Default_Tooltip_4">
                                                <InputField
                                                    name="kitDescription2"
                                                    placeholder="Enter Description 2"
                                                    value={itemValue?.kitDescription2}
                                                    onChange={(e: any) => handleChangeKitAttribute(e, itemValue.kitNumber)}
                                                    className={itemValue?.kitErrors?.kitDescription2 ? 'controlValidation' : "" }
                                                 data-attribute="KitAttribute_kitDescription2_Input_2" />
                                                </Tooltip>
                                                {itemValue?.kitErrors?.kitDescription2 ? <p className='validMessage'>{itemValue?.kitErrors?.kitDescription2}</p> : ""}
                                            </p>                                       
                                            <p className="qty">
                                                <Quantity
                                                    name="quantity"
                                                    value={itemValue?.quantity}
                                                    onChange={(e: any) => handleChangeKitAttribute(e, itemValue.kitNumber)}
                                                    increment={() => increamentAddedQuantity(itemValue.kitNumber)}
                                                    decrement={() => decrementAddedQuantity(itemValue.kitNumber)}
                                                    disableFlg={itemValue?.quantity <= 1}
                                                    onKeyPress={(event: any) => { isMaxLength(event, 3); isNumber(event); }}
                                                 data-attribute="KitAttribute_quantity_Quantity_2" />
                                                {itemValue?.kitErrors?.quantity ? <p className='validMessage'>{itemValue?.kitErrors?.quantity}</p> : ""}
                                            </p>                                        
                                            <p className="kunit_price">
                                                <InputField
                                                    name="unitPrice"
                                                    placeholder="Enter Unit Price"
                                                    prefix='$'
                                                    value={itemValue.unitPrice || ''}
                                                    onChange={(e: any) => handleChangeKitAttribute(e, itemValue.kitNumber)}
                                                    onKeyPress={(event: any) => { isNumber(event) }}
                                                    onBlur={(event: any) => priceFormat(event, 'unitPrice', itemValue.kitNumber)}
                                                    className={itemValue?.kitErrors?.unitPrice ? 'controlValidation' : "" }
                                                 data-attribute="KitAttribute_unitPrice_Input_2" />
                                                {itemValue?.kitErrors?.unitPrice ? <p className='validMessage'>{itemValue?.kitErrors?.unitPrice}</p> : ""}
                                            </p>                                    
                                            <button className="status" onClick={() => props?.handleClickRemoveRow(itemValue.kitNumber)} data-attribute="KitAttribute_Default_Button_2">
                                                <div className="deleteicon">
                                                    <span className="fa fa-trash-o"></span>
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                )
                            })
                        }
                        <div className="m-3">
                            <strong>Total Kit Price</strong>: ${formatPrice(getTotalKitPrice(), 2)}
                        </div>
                </div>
            </div>
        </Col>
        </Row>)
}

export default KitAttribute